import Constants from './Constants';

const drawImage = (ctx, transform, image, imageElement, staticSize = false) => {
  let width = imageElement.getAttribute('width') * transform.k;
  if (staticSize) {
    width = imageElement.getAttribute('width');
  }

  let [x, y] = transform.apply([
    imageElement.getAttribute('x'),
    imageElement.getAttribute('y'),
  ]);
  [x, y] = getFlooredCoordinates([x, y]);

  const ratio = Math.max(
    0.66,
    Math.min(
      1.2,
      imageElement.getAttribute('naturalHeight') /
        imageElement.getAttribute('naturalWidth'),
    ),
  );
  //const ratio = imageElement.getAttribute('naturalHeight') / imageElement.getAttribute('naturalWidth');

  const computedHeight = width * ratio;

  ctx.drawImage(
    image,
    0,
    0,
    imageElement.get('naturalWidth'),
    imageElement.get('naturalHeight'),
    x,
    y,
    width,
    computedHeight,
  );
};

const getFlooredCoordinates = coords => {
  return [Math.floor(coords[0]), Math.floor(coords[1])];
};

const drawGridPoints = (
  ctx,
  transform,
  gridPointOffset,
  gridPointRadius,
  width,
  height,
  viewPort,
) => {
  ctx.save();
  ctx.beginPath();

  for (let x = -width; x < viewPort.xmax; x += gridPointOffset * 2) {
    if (x < viewPort.xmin || x > viewPort.xmax) {
      continue;
    }
    for (let y = -height; y < viewPort.ymax; y += gridPointOffset * 2) {
      if (y < viewPort.ymin || y > viewPort.ymax) {
        continue;
      }

      const [x_transformed, y_transformed] = transform.apply([x, y]);
      ctx.fillStyle = '#ccc';
      ctx.fillRect(
        x_transformed,
        y_transformed,
        gridPointRadius * 10 * transform.k,
        gridPointRadius * 10 * transform.k,
      );
    }
  }

  ctx.restore();
};

export function splitStringForMultiLine(
  text,
  maxCharacterWidth,
  maxLines,
  ellipsis,
) {
  const lines = [];
  let currentLine = '';

  let i = 0;
  for (const word of text.split(' ')) {
    if (
      i > 0 &&
      currentLine.length + word.length + 1 > maxCharacterWidth &&
      lines.length + 1 < maxLines
    ) {
      lines.push(currentLine);
      currentLine = '';
    }

    currentLine += word + ' ';
    if (currentLine.length > maxCharacterWidth) {
      if (ellipsis) {
        currentLine = currentLine.slice(0, maxCharacterWidth) + '...';
      }
    }
    i++;
  }

  lines.push(currentLine);

  return lines;
}

const drawMultiLineString = (
  ctx,
  text,
  x,
  y,
  maxCharacterWidth,
  lineHeight,
  maxLines,
  ellipsis = false,
) => {
  /*if elipsis is true, shows ... for text that does not fit anymore*/
  const lines = splitStringForMultiLine(
    text,
    maxCharacterWidth,
    maxLines,
    ellipsis,
  );

  for (let i = 0; i < lines.length; i++) {
    if (i + 1 === maxLines && lines.length > maxLines) {
      if (ellipsis) {
        //fill line up with dots
        ctx.fillText(lines[i] + '...', x, y + i * lineHeight);
      } else {
        ctx.fillText(
          lines.slice(i, lines.length - 1).join(' '),
          x,
          y + i * lineHeight,
        );
      }
      break;
    } else {
      ctx.fillText(lines[i], x, y + i * lineHeight);
    }
  }
};

const drawGridLines = (
  ctx,
  transform,
  gridLineOffset,
  gridLineWidth,
  width,
  height,
  viewPort,
) => {
  ctx.save();
  //ctx.setLineDash([transform.k * 0.5, transform.k * 0.5]);
  // grid width and height
  const gridWidth = width;
  const gridHeight = height;
  // padding around grid
  /*
  for (let x = -gridWidth; x <= 2 * gridWidth; x += gridLineOffset) {
    let [x_start, y_start] = [x, -gridHeight];
    let [x_end, y_end] = [x, gridHeight * 2];

    // check if line needs to be drawn
    if (x_start < viewPort.xmin && x_end < viewPort.xmin ||
      y_start < viewPort.ymin && y_end < viewPort.ymin ||
      x_start > viewPort.xmax || y_start > viewPort.ymax) {
      continue;
    }

    [x_start, y_start] = transform.apply([x_start, y_start]);
    [x_end, y_end] = transform.apply([x_end, y_end]);

    [x_start, y_start] = getFlooredCoordinates([x_start, y_start]);
    [x_end, y_end] = getFlooredCoordinates([x_end, y_end]);

    ctx.moveTo(x_start, y_start);
    ctx.lineTo(x_end, y_end);
  }*/

  for (let x = -gridHeight; x <= gridHeight * 2; x += gridLineOffset) {
    let [x_start, y_start] = [-gridWidth, x];
    let [x_end, y_end] = [2 * gridWidth, x];
    if (
      (x_start < viewPort.xmin && x_end < viewPort.xmin) ||
      (y_start < viewPort.ymin && y_end < viewPort.ymin) ||
      x_start > viewPort.xmax ||
      y_start > viewPort.ymax
    ) {
      continue;
    }

    [x_start, y_start] = transform.apply([x_start, y_start]);
    [x_end, y_end] = transform.apply([x_end, y_end]);

    [x_start, y_start] = getFlooredCoordinates([x_start, y_start]);
    [x_end, y_end] = getFlooredCoordinates([x_end, y_end]);

    ctx.moveTo(x_start, y_start);
    ctx.lineTo(x_end, y_end);
  }

  ctx.lineWidth = gridLineWidth * transform.k;
  ctx.strokeStyle = Constants.grid.color;
  ctx.stroke();

  ctx.restore();
};

export { drawGridLines, drawGridPoints, drawImage, drawMultiLineString };
